import { ModalCustom } from "components/ModalCustom";
import { PrimaryButton } from "components/Button/style";
import { IconeContainer, InfoContainer, TextContainer } from "./style";
import { FaRedo, FaTimes } from "react-icons/fa";
import { CopiarChassi } from "../../CopiarChassi";

interface Props {
  show: boolean;
  handleClose: () => void;
  onClickOk: () => void;
  onClickReprocessar: () => void;
  mensagemErro: string | null;
  chassi?: string;
  idProcesso?: number;
}

export function ModalErroEtapaSemManual({
  show,
  handleClose,
  onClickOk,
  onClickReprocessar,
  mensagemErro,
  chassi,
  idProcesso,
}: Props) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Erro"
      centered
      adaptive
    >
      <InfoContainer>
        <IconeContainer>
          <FaTimes />
        </IconeContainer>
        <TextContainer>
          {!!idProcesso && (
            <span
              style={{ display: "block", fontWeight: 600, marginBottom: 4 }}
            >
              ID Processo: {idProcesso}
            </span>
          )}
          {mensagemErro ?? "Erro ao processar dados."}
        </TextContainer>
        {!!chassi && <CopiarChassi chassi={chassi} />}
      </InfoContainer>
      <div className="d-flex justify-content-end gap-4 mt-4">
        <PrimaryButton
          style={{ width: "14rem" }}
          outline
          variante="primary"
          onClick={onClickOk}
        >
          Ok
        </PrimaryButton>
        <PrimaryButton style={{ width: "10rem" }} onClick={onClickReprocessar}>
          Reprocessar <FaRedo />
        </PrimaryButton>
      </div>
    </ModalCustom>
  );
}
